import { Link as RouterLink } from 'react-router-dom';

import Button from 'components/partials/button/button';

import Icons from 'assets/icons';

export interface ClientReportRow {
  id: string | number;
  title?: string;
  description?: string;
  productId?: string | number;
  [key: string]: unknown;
}

export interface ClientProductOption {
  id: string | number;
  name?: string;
  [key: string]: unknown;
}

interface InfoArg {
  getValue: () => unknown;
  renderValue: () => React.ReactNode;
  row: { original: ClientReportRow };
}

interface ClientReportsColumnDef {
  id: string;
  accessorKey?: string;
  header: () => React.JSX.Element;
  cell: (info: InfoArg) => React.ReactNode;
  headerClassName?: string;
  className?: string;
  enableSorting?: boolean;
  sortingFn?: string;
}

const commonStyles = 'pl-4 border-r-2 border-white font-semibold';

export const getClientReportsTableSettings = (
  clientId: string | number | undefined,
  products: ClientProductOption[] = [],
): ClientReportsColumnDef[] => [
  {
    id: 'title',
    accessorKey: 'title',
    header: () => <span>REPORT NAME</span>,
    cell: (info) => info.renderValue(),
    headerClassName: `${commonStyles} cursor-pointer rounded-tl-md rounded-bl-md`,
    className: 'pl-4 tablet:w-[30%] font-semibold',
    enableSorting: true,
    sortingFn: 'alphanumeric',
  },
  {
    id: 'description',
    accessorKey: 'description',
    header: () => <span>DESCRIPTION</span>,
    cell: (info) => <span>{info.renderValue() as React.ReactNode}</span>,
    headerClassName: `${commonStyles}`,
    className: 'pl-4 tablet:w-[35%]',
    enableSorting: false,
  },
  {
    id: 'productId',
    accessorKey: 'productId',
    header: () => <span>PRODUCT</span>,
    cell: (info) => {
      const productId = info.getValue() as string | number;

      const product = products.find((p) => p.id === productId);

      return product ? (
        <RouterLink to={`/admin/clients/${clientId}/products/${productId}`}>
          <span className="text-blue-700 underline">{product.name}</span>
        </RouterLink>
      ) : (
        <span className="text-gray-500">Not assigned</span>
      );
    },
    headerClassName: `${commonStyles} cursor-pointer`,
    className: 'pl-4 tablet:w-[20%]',
    enableSorting: true,
  },
  {
    id: 'button-cell',
    header: () => <span></span>,
    cell: ({
      row: {
        original: { id },
      },
    }) => (
      <RouterLink to={`/admin/clients/${clientId}/reports/${id}`}>
        <Button
          variant="reserve-outlined"
          size="sm"
          iconBefore={<Icons.Eye aria-label="EyeIcon" />}
          className="text-xs md:text-sm"
        >
          View Details
        </Button>
      </RouterLink>
    ),
    headerClassName: 'h-12 rounded-tr-md rounded-br-md',
    className: 'py-3 pl-4',
  },
];
